__turbopack_context__.v({
  "actions": "i9pkHa_actions",
  "button": "i9pkHa_button",
  "button2": "i9pkHa_button2",
  "button__bo8Fw": "i9pkHa_button__bo8Fw",
  "col": "i9pkHa_col",
  "header": "i9pkHa_header",
  "heading": "i9pkHa_heading",
  "svg__cnwxa": "i9pkHa_svg__cnwxa",
  "svg__exemg": "i9pkHa_svg__exemg",
  "svg__fbnLw": "i9pkHa_svg__fbnLw",
  "svg__irzKw": "i9pkHa_svg__irzKw",
  "svg__jlSkZ": "i9pkHa_svg__jlSkZ",
  "svg__ze6QT": "i9pkHa_svg__ze6QT",
  "text": "i9pkHa_text",
  "text__cjyfa": "i9pkHa_text__cjyfa",
  "text__pGDx": "i9pkHa_text__pGDx",
  "text__wsCq3": "i9pkHa_text__wsCq3",
});
